import { useSelector } from "react-redux";
import { RootState } from "../store/reducers/types/root";
import { DefinedUseQueryResult, useQuery } from "@tanstack/react-query";
import { ApiPaths, UserApiPaths } from "../services/paths";
import React from "react";
import { GetProjectRequest, GetProjectResponse } from "../services/types";
import { apiGetProject } from "../services/project";
import { AxiosResponse } from "axios";

interface UseProjectProps {
  enabled?: boolean;
  defaultBody: GetProjectRequest;
}

export function useProject({
  enabled = true,
  defaultBody,
}: UseProjectProps): [
  DefinedUseQueryResult<AxiosResponse<GetProjectResponse, any> | null, Error>,
  React.Dispatch<React.SetStateAction<GetProjectRequest>>
] {
  const token = useSelector((state: RootState) => state.user.token);
  const [body, setBody] = React.useState<GetProjectRequest>(defaultBody);
  const data = useQuery({
    queryKey: [ApiPaths.USER, UserApiPaths.LOAD_USER, token, body],
    enabled: false,
    initialData: null,
    queryFn: () => apiGetProject(token as string, body),
  });

  React.useEffect(() => {
    if (enabled && token) {
      data.refetch();
    }
  }, [token, body]);

  return [data, setBody];
}
